import { ImageWithText } from '@quicktools/shared-components/components/landingPages/ImageWithText';
import { ImageWithTextListContained } from '@quicktools/shared-components/components/landingPages/ImageWithTextListContained';
import { IMG_WITH_TEXT_SIZES } from '@quicktools/shared-components/components/landingPages/constants';
import { memo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { SingleToolSimilar } from '@quicktools/shared-components/components/common/SingleToolSimilar';
import {
  MARKETING_SLOGAN_TOOL,
  AD_COPY_GENERATOR_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  FONT_GENERATOR_TOOL,
  ToolCategory,
} from '@quicktools/shared-components/data';

import analytics from '../../../services/analytics';

import useStyles from './styles';

const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

function StaticSection() {
  const { t } = useTranslation();
  const classes = useStyles();

  const items = [0, 1, 2, 3].map((i) => ({
    title: t(`static.Symbols.contained.items.${i}.title`),
    description: t(`static.Symbols.contained.items.${i}.description`),
    alt: t(`static.Symbols.contained.items.${i}.alt`),
    src: t(`static.Symbols.contained.items.${i}.src`),
  }));

  return (
    <div className={classes.root}>
      <ImageWithText
        imageRight
        alt={t('static.Symbols.imageWithText.alt')}
        title={
          <Trans i18nKey="static.Symbols.imageWithText.title" components={{ strong: <strong /> }} />
        }
        description={
          <Trans
            i18nKey="static.Symbols.imageWithText.description"
            components={{ span: <span />, a: <a /> }}
          />
        }
        src="https://pastatic.picsart.com/cms-pastatic/74087828-d2ef-47cc-a6ff-f14407c2c216.png"
        srcSet="https://pastatic.picsart.com/cms-pastatic/76f0bbb7-7a5f-43c3-be04-95a534824857.png 327w,https://pastatic.picsart.com/cms-pastatic/74087828-d2ef-47cc-a6ff-f14407c2c216.png 648w"
        sizes={IMG_WITH_TEXT_SIZES}
      />
      <ImageWithTextListContained
        title={<Trans i18nKey="static.Symbols.contained.title" components={{ b: <b /> }} />}
        items={items}
      />
      <SingleToolSimilar
        current={FONT_GENERATOR_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('similarTxt')}
        category={ToolCategory.Text}
      />
    </div>
  );
}

export default memo(StaticSection);
